// src/App.js
import React, { useState } from 'react';
import './App.css';

const gamesData = [
  {
    name: "Snake Game",
    url: "https://ami-darshan.github.io/Snake/", // Replace with your website URL
    image: "https://i.ibb.co/nR3qrS6/Default-snake-game-logo-3.jpg" // Placeholder image URL
  },
  {
    name: "Bubble Shooter",
    url: "https://ami-darshan.github.io/Bubble-Shooter/",
    image: "https://i.ibb.co/ZzRvsp5/Default-Bubble-shooter-game-logo-3.jpg"
  },
  {
    name: "Rock Paper Scissors",
    url: "https://ami-darshan.github.io/RPS/",
    image: "https://i.ibb.co/68HGxpx/Default-Rock-Paper-Scissors-Game-Logo-3.jpg"
  },
  {
    name: "Tic Tac Toe",
    url: "https://ami-darshan.github.io/TicTacToe/",
    image: "https://i.ibb.co/c3SGrhz/Default-tic-tac-toe-game-logo-3.jpg"
  },
  {
    name: "Flappy Bird",
    url: "https://ami-darshan.github.io/flaps/",
    image: "https://i.ibb.co/f4hGwjc/Default-Flappy-Bird-Game-Logo-0.jpg"
  },
  {
    name: "PacMan",
    url: "https://ami-darshan.github.io/Pacman/",
    image: "https://i.ibb.co/RYrgcRT/pacman.jpg"
  },
];

const App = () => {
  const [displayedUrl, setDisplayedUrl] = useState("");

  const handleGameClick = (url) => {
    setDisplayedUrl(url);
  };

  const handleBackClick = () => {
    setDisplayedUrl("");
  };

  return (
    <div className="App">
      <div className="header-sections">
        <a href="" className="section">Home</a>
        <a href="https://ami-darshan.github.io/Privacy-Policy/" className="section">Privacy Policy</a>
        <a href="https://ami-darshan.github.io/premium-app/" className="section">Buy Premium</a>

      </div>
      <h1 className="title">FunFusion</h1>
      <div className="game-container">
        {gamesData.map((game, index) => (
          <div key={index} className="game-item" onClick={() => handleGameClick(game.url)}>
            <img src={game.image} alt="Game" className="game-image" />
            <p className="game-name">{game.name}</p>
          </div>
        ))}
      </div>
      {displayedUrl ? (
        <div className="displayed-url-container">
          <button className="back-button" onClick={handleBackClick}>Back</button>
          {displayedUrl.includes("privacypolicy.html") ? (
            <iframe className="displayed-website" src={displayedUrl} title="Privacy Policy"></iframe>
          ) : (
            <iframe className="displayed-website" src={displayedUrl} title="Displayed Website"></iframe>
          )}
        </div>
      ) : null}
    </div>
  );
  };
  
  export default App;
  